import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import store from './store/store';
import { Provider } from "react-redux";
import { AuthProvider } from './context/AuthContext';
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster as Sonner } from "./components/ui/sonner";
import { Toaster } from "./components/ui/toaster";
import { TooltipProvider } from "./components/ui/tooltip";
import { AuthOverlayProvider } from "./overlay/AuthOverlay";
import { BrowserRouter } from 'react-router-dom';
import { CommonProvider } from './context/CommonContext';
import { GameProvider } from './context/GameContext';
import { SettingsProvider } from './context/SettingsContext';
const root = ReactDOM.createRoot(document.getElementById('root'));
const queryClient = new QueryClient();

root.render(
  <React.StrictMode>
	<Provider store={store}>
		<QueryClientProvider client={queryClient}>
			<TooltipProvider>
				<Toaster />
				<Sonner />
				<SettingsProvider>
					<CommonProvider>
						<BrowserRouter>
							<AuthProvider>
								<AuthOverlayProvider>
									<GameProvider>
										<App />
									</GameProvider>
								</AuthOverlayProvider>
							</AuthProvider>
						</BrowserRouter>
					</CommonProvider>
				</SettingsProvider>
			</TooltipProvider>
		</QueryClientProvider>
	</Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
